import React from 'react';
import DownloadApi from 'Services/Api/Download/Download';
import { Redirect } from "react-router-dom";
import { useParams } from "react-router-dom"
import queryString from 'query-string'
import { Loading } from "Components/Partials";
import { useHistory } from "react-router-dom";



export default class Download extends React.Component {
    /**
     * @method handleSubmit
     * @param {string} data
     * @return {JSX.Element}
     */
    async handleSubmit( data ) {
        const response = await DownloadApi.download ( data );

        if ( response.success ) {
            this.setState ( {
                'downloaded': true
            } );
        }
    }

    state = {
        working: true,
        download: false
    };
    async componentDidMount(props){
        const queryParameters = new URLSearchParams(window.location.search);
        const key = queryParameters.get("key");

        if (key) {
            await this.handleSubmit ( key )
        }
    }

    render(){
        const {downloaded} = this.state;

        if(downloaded){
           return <Redirect to="/" />
        }

        return(
            <Loading></Loading>
        );
    }
}
